import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadContractRevenueRentListStatus: 'idle',
    loadContractRevenueRentListError: undefined as any,
    loadContractRevenueRentListLastArgs: undefined as any,
    loadContractRevenueRentStatus: 'idle',
    loadContractRevenueRentError: undefined as any,
    saveContractRevenueRentStatus: 'idle',
    saveContractRevenueRentError: undefined as any,
    deleteContractRevenueRentStatus: 'idle',
    deleteContractRevenueRentError: undefined as any,

    flustList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadContractRevenueRentList = createAsyncThunk('flustSlice/loadContractRevenueRentList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flustSlice.loadContractRevenueRentListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/flust/?action=gte&MIN_VTRID=${parentModel.HDR_ID}&MAX_VTRID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractRevenueRentListStatus } = getState().flustSlice
        return loadContractRevenueRentListStatus !== 'pending'
    }
})

export const loadContractRevenueRent = createAsyncThunk('flustSlice/loadContractRevenueRent', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flust/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractRevenueRentStatus } = getState().flustSlice
        return loadContractRevenueRentStatus !== 'pending'
    }
})

export const saveContractRevenueRent = createAsyncThunk('flustSlice/saveContractRevenueRent', async ({ flust }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flust?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flust/${ flust?.HDR_ID }/`,
            prepareData(flust),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flust/`,
            prepareData(flust),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveContractRevenueRentStatus } = getState().flustSlice
        return saveContractRevenueRentStatus !== 'pending'
    }
})

export const deleteContractRevenueRent = createAsyncThunk('flustSlice/deleteContractRevenueRent', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flust/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteContractRevenueRentStatus } = getState().flustSlice
        return deleteContractRevenueRentStatus !== 'pending'
    }
})

const FlustSlice = createSlice({
    name: 'flustSlice',
    initialState,
    reducers: {
        resetloadContractRevenueRentListError: (state) => {
            state.loadContractRevenueRentListError = undefined
        },
        resetloadContractRevenueRent: (state) => {
            state.formItem = undefined
            state.loadContractRevenueRentError = undefined
        },
        resetloadContractRevenueRentError: (state) => {
            state.loadContractRevenueRentError = undefined
        },
        resetsaveContractRevenueRent: (state) => {
            state.formItem = undefined
            state.saveContractRevenueRentError = undefined
        },
        resetsaveContractRevenueRentError: (state) => {
            state.saveContractRevenueRentError = undefined
        },
        resetdeleteContractRevenueRentError: (state) => {
            state.deleteContractRevenueRentError = undefined
        },
        removeFromFlustListById: (state, action) => {
            state.flustList = state.flustList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlustListByIds: (state, action) => {
            state.flustList = state.flustList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flustList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadContractRevenueRentListStatus = 'preloaded'
            state.loadContractRevenueRentListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.flustList = []
            state.loadContractRevenueRentListStatus = 'idle'
            state.loadContractRevenueRentListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadContractRevenueRentList.pending, (state) => {
            state.loadContractRevenueRentListStatus = 'pending'
            state.loadContractRevenueRentListError = undefined
        })
        builder.addCase(loadContractRevenueRentList.fulfilled, (state, action) => {
            state.loadContractRevenueRentListStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractRevenueRentListLastArgs = action.payload.args

            {
                state.flustList = action.payload.data

            }
        })
        builder.addCase(loadContractRevenueRentList.rejected, (state, action) => {
            state.loadContractRevenueRentListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRevenueRentListError = action.error.message
            } else {
                state.loadContractRevenueRentListError = action.payload
            }
        })

        builder.addCase(loadContractRevenueRent.pending, (state) => {
            state.loadContractRevenueRentStatus = 'pending'
            state.loadContractRevenueRentError = undefined
        })
        builder.addCase(loadContractRevenueRent.fulfilled, (state, action) => {
            state.loadContractRevenueRentStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flustList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flustList.push(newItem) }
                else { state.flustList[i] = { ...state.flustList[i], ...newItem } }
            }
        })
        builder.addCase(loadContractRevenueRent.rejected, (state, action) => {
            state.loadContractRevenueRentStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRevenueRentError = action.error.message
            } else {
                state.loadContractRevenueRentError = action.payload
            }
        })

        builder.addCase(saveContractRevenueRent.pending, (state) => {
            state.saveContractRevenueRentStatus = 'pending'
            state.saveContractRevenueRentError = undefined
        })
        builder.addCase(saveContractRevenueRent.fulfilled, (state, action) => {
            state.saveContractRevenueRentStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flustList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flustList.push(newItem) }
                else { state.flustList[i] = { ...state.flustList[i], ...newItem } }
            }
        })
        builder.addCase(saveContractRevenueRent.rejected, (state, action) => {
            state.saveContractRevenueRentStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveContractRevenueRentError = action.error.message
            } else {
                state.saveContractRevenueRentError = action.payload
            }
        })

        builder.addCase(deleteContractRevenueRent.pending, (state) => {
            state.deleteContractRevenueRentStatus = 'pending'
            state.deleteContractRevenueRentError = undefined
        })
        builder.addCase(deleteContractRevenueRent.fulfilled, (state, action) => {
            state.deleteContractRevenueRentStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.flustList = state.flustList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.flustList = state.flustList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteContractRevenueRent.rejected, (state, action) => {
            state.deleteContractRevenueRentStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteContractRevenueRentError = action.error.message
            } else {
                state.deleteContractRevenueRentError = action.payload
            }
        })

    }
})

export const {
    resetloadContractRevenueRentListError,
    resetloadContractRevenueRent,
    resetloadContractRevenueRentError,
    resetsaveContractRevenueRent,
    resetsaveContractRevenueRentError,
    resetdeleteContractRevenueRentError,
    removeFromFlustListById,
    removeFromFlustListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlustSlice.actions
export default FlustSlice.reducer
